// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__3FeGR","filesListContainer":"PosDisputesFiles_filesListContainer__24_N-","filesButton":"PosDisputesFiles_filesButton__1Xv9G"};